import React, { useEffect, useState, useContext } from "react";
//import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { Link, useNavigate } from "react-router-dom";
import "../../../css/custom.css";
import ReactCountryFlag from "react-country-flag";
import "../../../css/header2.css";
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import Modal from "./model";
import Modal2 from "./model2";
import ContactUs from "./contactUs";

const Header = () => {


    const [cartMessage, setCartMessage] = useState('');
    const [wishListMessage, setWishListMessage] = useState('');
    //const { cart, wishlist, setCart, setWishlist } = useContext(CartContext);
    const [cart, setCart] = useState(0);  // Initialize cart state
    const [wishlist, setWishlist] = useState(0);  // Initialize wishlist state

    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const [paintingByStyle, setPaintingByStyle] = useState([]);
    const [paintingBySurface, setPaintingBySurface] = useState([]);
    const [paintingBySubject, setPaintingBySubject] = useState([]);
    const [paintingByMaterial, setPaintingByMaterial] = useState([]);

    const [drawingByStyle, setDrawingByStyle] = useState([]);
    const [drawingBySurface, setDrawingBySurface] = useState([]);
    const [drawingBySubject, setDrawingBySubject] = useState([]);
    const [drawingByMaterial, setDrawingByMaterial] = useState([]);

    const [printmakByStyle, setPrintmakByStyle] = useState([]);
    const [printmakBySurface, setPrintmakBySurface] = useState([]);
    const [printmakBySubject, setPrintmakBySubject] = useState([]);
    const [printmakByMaterial, setPrintmakByMaterial] = useState([]);

    const [tapestryByStyle, setTapestryByStyle] = useState([]);
    const [tapestryBySurface, setTapestryBySurface] = useState([]);
    const [tapestryBySubject, setTapestryBySubject] = useState([]);
    const [tapestryByMaterial, setTapestryByMaterial] = useState([]);

    const [sculptureByStyle, setSculptureByStyle] = useState([]);
    const [sculptureBySurface, setSculptureBySurface] = useState([]);
    const [sculptureBySubject, setSculptureBySubject] = useState([]);
    const [sculptureByMaterial, setSculptureByMaterial] = useState([]);

    const [legendArtists, setLegendArtists] = useState([]);
    const [establishedArtists, setEstablishedArtists] = useState([]);
    const [upcomingArtists, setUpcomingArtists] = useState([]);

    const { currencyContxt, updateCurrencyContxt } = useContext(CurrencyContext); // Use context

    const formatDate = (dateString) => {
        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };
        return new Date(dateString).toLocaleString('en-US', options).replace(',', '');
    };

    const fetchCartAndWishlist = async () => {

        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            if (userInfo && userInfo.buyer_id) {
                const buyer_id = userInfo.buyer_id; // Extract buyer_id from local storage

                // Fetch Cart Data from API
                const cartResponse = await fetch(`https://igapi.heuristticminds.com/api/CartList/Get-GetCartCountByBuyerID?buyer_id=${buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });
                const cartData = await cartResponse.json();
                setCart(cartData.count);  // Update cart count in state

                // Fetch Wishlist Data from API
                const wishlistResponse = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListCountByBuyerID?buyer_id=${buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });
                const wishlistData = await wishlistResponse.json();
                setWishlist(wishlistData.count);  // Update wishlist count in state

            } else {
                // If user is not logged in, get counts from localStorage
                const cartData = JSON.parse(localStorage.getItem('cart')) || [];
                const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
                setCart(cartData.length);  // Ensure it's a number from localStorage
                setWishlist(wishlistData.length);  // Ensure it's a number from localStorage
            }
        } catch (error) {
            console.error("Error fetching cart/wishlist data:", error);
        }
    };

    // Check if user is logged in and fetch data if logged in
    useEffect(() => {
        fetchCartAndWishlist();
    }, [fetchCartAndWishlist]);

    const handleCartClick = () => {
        if (cart > 0) {
            navigate('/myCart');
            window.scrollTo({
                top: 0,
                behavior: "instant"
            });
        } else {
            setCartMessage('Your cart is empty !!');
            toast.info('Your cart is empty !!');
        }
    };
    const handleWishListClick = () => {
        if (wishlist > 0) {
            navigate('/myWishlist');
            window.scrollTo({
                top: 0,
                behavior: "instant"
            });
        } else {
            setWishListMessage('Your Wishlist is empty !!');
            toast.info('Your WishList is empty !!');
        }
    };


    //Search Box Logic Starts

    useEffect(() => {
        const fetchResults = async () => {
            if (query.length > 2) {
                setLoading(true);
                try {
                    const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetSearchBoxList', {
                        params: { searchText: query }
                    });
                    setResults(response.data);

                } catch (error) {
                    console.error('API error:', error);
                } finally {
                    setLoading(false);
                }
            } else {
                setResults([]);
            }
        };

        const debouncedFetchResults = debounce(fetchResults, 300);
        debouncedFetchResults();

        return () => {
            debouncedFetchResults.cancel();
        };
    }, [query]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && query.trim()) {
            //navigate(`/search?query=${query.trim()}`);
            const search = "all?search=" + query.trim(); // Format the name for the URL
            navigate(`/artworks/${search}`, { state: { categoryId: 0, subCategoryId: 0, typeId: 0, searchText: query.trim() } });
        }
    };

    const handleSearchClick = () => {
        if (query.trim()) {
            //navigate(`/search?query=${query.trim()}`);

            const search = "all?search=" + query.trim(); // Format the name for the URL
            navigate(`/artworks/${search}`, { state: { categoryId: 0, subCategoryId: 0, typeId: 0, searchText: query.trim() } });
        }
    };

    const handleSelect = (item) => {

        switch (item.type) {
            case 'Subject':
                const categoryId = 0
                const subCategoryId = 3; // Assuming you are navigating to a Subject
                const typeId = item.id; // The selected item's ID

                const subject = "all/" + item.name.replace(/ /g, "-"); // Format the name for the URL
                navigate(`/artworks/${subject}-${typeId}`, { state: { categoryId, subCategoryId, typeId, searchText: '' } });
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            case 'Artist':
                const artist = item.name.replace(/ /g, '-'); // Replace spaces with '-'
                navigate(`/artist/${artist}-${item.id}`, { state: { artistId: item.id } });
                //navigate(`/artist/${item.id}`);
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            case 'Style':
                const style = 'all/' + item.name.replace(/ /g, '-'); // Replace spaces with '-'
                //navigate(url, { state: { categoryId: 0, subCategoryId: 3, typeId: item.id } });
                navigate(`/artworks/${style}-${item.id}`, { state: { categoryId: 0, subCategoryId: 1, typeId: item.id, searchText: '' } });
                //navigate(`/style?style=${item.name}`);
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            case 'Surface':
                const surface = "all/" + item.name.replace(/ /g, "-"); // Format the name for the URL
                navigate(`/artworks/${surface}-${item.id}`, { state: { categoryId: 0, subCategoryId: 2, typeId: item.id, searchText: '' } });
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            case 'Material':
                //navigate(`/material?category=${item.name}`);

                const medium = "all/" + item.name.replace(/ /g, "-"); // Format the name for the URL
                navigate(`/artworks/${medium}-${item.id}`, { state: { categoryId: 0, subCategoryId: 4, typeId: item.id, searchText: '' } });
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            case 'Artwork':
                const formattedTitle = item.name.replace(/ /g, '-'); // Replace spaces with '-'
                navigate(`/artwork/${formattedTitle}-${item.id}`, { state: { id: item.id } });
                //navigate(`/artwork/${item.id}`);
                window.scrollTo({
                    top: 0,
                    behavior: "instant"
                });
                break;
            default:
                break;
        }
    };

    const renderResults = () => {
        if (results.length === 0) return null;

        const groupedResults = results.reduce((acc, result) => {
            if (!acc[result.type]) acc[result.type] = [];
            acc[result.type].push(result);
            return acc;
        }, {});

        return (
            <div className="results-container">
                {Object.keys(groupedResults).map((type, index) => (
                    <div key={index} className="result-group">
                        <div className="group-header">{type}(s)</div>
                        {groupedResults[type].map((result, idx) => (
                            <div key={idx} className="result-item" onClick={() => handleSelect(result)}>
                                {result.name}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };


    //Search Box Logic Ends

    function fetchPaintingStyle() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=72')
            .then(response => response.json()).then(data => setPaintingByStyle(data)).catch(error => console.error('Error fetching data:', error));
    }

    function fetchPaintingSurface() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=72')
            .then(response => response.json()).then(data => setPaintingBySurface(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchPaintingSubject() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=72')
            .then(response => response.json()).then(data => setPaintingBySubject(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchPaintingMaterial() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=72')
            .then(response => response.json()).then(data => setPaintingByMaterial(data)).catch(error => console.error('Error fetching data:', error));
    }

    function fetchDrawingStyle() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=73')
            .then(response => response.json()).then(data => setDrawingByStyle(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchDrawingSurface() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=73')
            .then(response => response.json()).then(data => setDrawingBySurface(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchDrawingSubject() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=73')
            .then(response => response.json()).then(data => setDrawingBySubject(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchDrawingMaterial() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=73')
            .then(response => response.json()).then(data => setDrawingByMaterial(data)).catch(error => console.error('Error fetching data:', error));
    }

    function fetchPrintmakStyle() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=74')
            .then(response => response.json()).then(data => setPrintmakByStyle(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchPrintmakSurface() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=74')
            .then(response => response.json()).then(data => setPrintmakBySurface(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchPrintmakSubject() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=74')
            .then(response => response.json()).then(data => setPrintmakBySubject(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchPrintmakMaterial() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=74')
            .then(response => response.json()).then(data => setPrintmakByMaterial(data)).catch(error => console.error('Error fetching data:', error));
    }

    function fetchTapestryStyle() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=103')
            .then(response => response.json()).then(data => setTapestryByStyle(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchTapestrySurface() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=103')
            .then(response => response.json()).then(data => setTapestryBySurface(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchTapestrySubject() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=103')
            .then(response => response.json()).then(data => setTapestryBySubject(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchTapestryMaterial() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=103')
            .then(response => response.json()).then(data => setTapestryByMaterial(data)).catch(error => console.error('Error fetching data:', error));
    }


    function fetchSculptureStyle() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindStyleByArtwork?artwork=134')
            .then(response => response.json()).then(data => setSculptureByStyle(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchSculptureSurface() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSurfaceByArtwork?artwork=134')
            .then(response => response.json()).then(data => setSculptureBySurface(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchSculptureSubject() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindSubjectByArtwork?artwork=134')
            .then(response => response.json()).then(data => setSculptureBySubject(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchSculptureMaterial() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindMaterialByArtwork?artwork=134')
            .then(response => response.json()).then(data => setSculptureByMaterial(data)).catch(error => console.error('Error fetching data:', error));
    }

    function fetchLegendArtists() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindLegendArtistList')
            .then(response => response.json()).then(data => setLegendArtists(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchEstablished() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindEstablishedArtistList')
            .then(response => response.json()).then(data => setEstablishedArtists(data)).catch(error => console.error('Error fetching data:', error));
    }
    function fetchUpcomingArtists() {
        fetch('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindUpcomingArtistList')
            .then(response => response.json()).then(data => setUpcomingArtists(data)).catch(error => console.error('Error fetching data:', error));
    }

    const navigate = useNavigate();

    // Change by Ranjan on 07 Nov 2024 ro routing
    const categoryMapping = {
        72: "painting",
        73: "drawing",
        74: "printmaking",
        103: "tapestry",
        134: "sculpture",
    };
    const PdCategory = ({ categoryId, subCategoryId, typeId, typeName }) => {

        // Get the category name based on the categoryId and styleId
        const categoryName = categoryMapping[categoryId];
        const type = typeName.replace(/ /g, '-'); // Replace spaces with '-'
        if (categoryName) {
            // Use navigate with categoryName instead of categoryId

            let url = `/artworks/${categoryName}`;

            // If subCategoryId is not 0, append styleName to the URL
            if (subCategoryId !== 0) {
                url += `/${type}`;
            }

            navigate(url, { state: { categoryId: categoryId, subCategoryId: subCategoryId, typeId: typeId, searchText: '' } });
            window.scrollTo({
                top: 0,
                behavior: "instant"
            });
        } else {
            debugger;
            navigate(`/artworks/all`, { state: { categoryId: categoryId, subCategoryId: subCategoryId, typeId: typeId, searchText: '' } });
            //console.error("Invalid categoryId");
        }
    };

    // Change by Ranjan ends here

    const handleArtist = (artistId, artistName) => {
        const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId } });
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };



    const MegaMenu = ({ buttonText, menuItems }) => {
        const [isMenuOpen, setMenuOpen] = useState(false);
        const handleMouseEnter = () => {
            setMenuOpen(true);
        };
        const handleMouseLeave = () => {
            setMenuOpen(false);
        };
        return (
            <div className="mega-menu" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <span className={`menu-button ${isMenuOpen ? 'hvr' : ''}`}>{buttonText}</span>
                <div className={`mega_menu_dropdown ${isMenuOpen ? 'show' : 'hide'}`}>
                    <ul>
                        {menuItems.map((itm, index) => (
                            <li key={index}>{itm}</li>
                        ))}
                    </ul>
                </div>

            </div>
        );
    };

    const menuData = [
        {
            buttonText: <>

                <span onClick={(e) => PdCategory({ categoryId: 0, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                    Artworks<i className="bi bi-grid-fill"></i>
                </span>

            </>, menuItems: [<ul className="memu_artwork">
                <li onClick={(e) => PdCategory({ categoryId: 72, subCategoryId: 0, typeId: 0, typeName: '0' })}><span className="icon icon_painting"></span>Painting</li>
                <li onClick={(e) => PdCategory({ categoryId: 73, subCategoryId: 0, typeId: 0, typeName: '0' })}><span className="icon icon_drawing"></span>Drawing</li>
                <li onClick={(e) => PdCategory({ categoryId: 74, subCategoryId: 0, typeId: 0, typeName: '0' })}><span className="icon icon_printmaking"></span>Printmaking</li>
                <li onClick={(e) => PdCategory({ categoryId: 103, subCategoryId: 0, typeId: 0, typeName: '0' })}><span className="icon icon_tapestry"></span>Tapestry</li>
                <li onClick={(e) => PdCategory({ categoryId: 134, subCategoryId: 0, typeId: 0, typeName: '0' })}><span className="icon icon_sculpture"></span>Sculpture</li>
            </ul>]
        },
        {
            buttonText: <><span onClick={(e) => PdCategory({ categoryId: 72, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                Painting<i className="bi bi-grid-fill"></i>
            </span>
            </>, menuItems: [
                <ul className="submenu">
                    <li className="type">Style</li>
                    {
                        paintingByStyle.map(styleList => (
                            <li key={styleList?.id} onClick={(e) => PdCategory({ categoryId: 72, subCategoryId: 1, typeId: styleList?.id, typeName: styleList?.style })}><Link>{styleList?.style}</Link></li>
                        ))
                    }
                </ul >,
                <ul className="submenu">
                    <li className="type">Surface</li>
                    {
                        paintingBySurface.map(surfaceList => (
                            <li key={surfaceList?.id} onClick={() => PdCategory({ categoryId: 72, subCategoryId: 2, typeId: surfaceList?.id, typeName: surfaceList?.surface })}><Link>{surfaceList?.surface}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Subject</li>
                    {
                        paintingBySubject.map(subjectList => (
                            <li key={subjectList?.id} onClick={() => PdCategory({ categoryId: 72, subCategoryId: 3, typeId: subjectList?.id, typeName: subjectList?.subject })}><Link>{subjectList?.subject}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Material</li>
                    {
                        paintingByMaterial.map(materialList => (
                            <li key={materialList?.id} onClick={() => PdCategory({ categoryId: 72, subCategoryId: 4, typeId: materialList?.id, typeName: materialList?.medium })}><Link>{materialList?.medium}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
        {
            buttonText: <>
                <span onClick={(e) => PdCategory({ categoryId: 73, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                    Drawing<i className="bi bi-grid-fill"></i>
                </span>
            </>, menuItems: [
                <ul className="submenu">
                    <li className="type">Style</li>
                    {
                        drawingByStyle.map(styleList => (
                            <li key={styleList?.id} onClick={() => PdCategory({ categoryId: 73, subCategoryId: 1, typeId: styleList?.id, typeName: styleList?.style })}><Link>{styleList?.style}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Surface</li>
                    {
                        drawingBySurface.map(surfaceList => (
                            <li key={surfaceList?.id} onClick={() => PdCategory({ categoryId: 73, subCategoryId: 2, typeId: surfaceList?.id, typeName: surfaceList?.surface })}><Link>{surfaceList?.surface}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Subject</li>
                    {
                        drawingBySubject.map(subjectList => (
                            <li key={subjectList?.id} onClick={() => PdCategory({ categoryId: 73, subCategoryId: 3, typeId: subjectList?.id, typeName: subjectList?.subject })}><Link>{subjectList?.subject}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Material</li>
                    {
                        drawingByMaterial.map(materialList => (
                            <li key={materialList?.id} onClick={() => PdCategory({ categoryId: 73, subCategoryId: 4, typeId: materialList?.id, typeName: materialList?.medium })}><Link>{materialList?.medium}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
        {
            buttonText: <>
                <span onClick={(e) => PdCategory({ categoryId: 74, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                    Printmaking<i className="bi bi-grid-fill"></i>
                </span>
            </>, menuItems: [
                <ul className="submenu">
                    <li className="type">Style</li>
                    {
                        printmakByStyle.map(styleList => (
                            <li key={styleList?.id} onClick={() => PdCategory({ categoryId: 74, subCategoryId: 1, typeId: styleList?.id, typeName: styleList?.style })}><Link>{styleList?.style}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Surface</li>
                    {
                        printmakBySurface.map(surfaceList => (
                            <li key={surfaceList?.id} onClick={() => PdCategory({ categoryId: 74, subCategoryId: 2, typeId: surfaceList?.id, typeName: surfaceList?.surface })}><Link>{surfaceList?.surface}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Subject</li>
                    {
                        printmakBySubject.map(subjectList => (
                            <li key={subjectList?.id} onClick={() => PdCategory({ categoryId: 74, subCategoryId: 3, typeId: subjectList?.id, typeName: subjectList?.subject })}><Link>{subjectList?.subject}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Material</li>
                    {
                        printmakByMaterial.map(materialList => (
                            <li key={materialList?.id} onClick={() => PdCategory({ categoryId: 74, subCategoryId: 4, typeId: materialList?.id, typeName: materialList?.medium })}><Link>{materialList?.medium}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
        {
            buttonText: <>
                <span onClick={(e) => PdCategory({ categoryId: 103, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                    Tapestry<i className="bi bi-grid-fill"></i>
                </span>
            </>, menuItems: [
                <ul className="submenu">
                    <li className="type">Style</li>
                    {
                        tapestryByStyle.map(styleList => (
                            <li key={styleList?.id} onClick={() => PdCategory({ categoryId: 103, subCategoryId: 1, typeId: styleList?.id, typeName: styleList?.style })}><Link>{styleList?.style}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Surface</li>
                    {
                        tapestryBySurface.map(surfaceList => (
                            <li key={surfaceList?.id} onClick={() => PdCategory({ categoryId: 103, subCategoryId: 2, typeId: surfaceList?.id, typeName: surfaceList?.surface })}><Link>{surfaceList?.surface}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Subject</li>
                    {
                        tapestryBySubject.map(subjectList => (
                            <li key={subjectList?.id} onClick={() => PdCategory({ categoryId: 103, subCategoryId: 3, typeId: subjectList?.id, typeName: subjectList?.subject })}><Link>{subjectList?.subject}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Material</li>
                    {
                        tapestryByMaterial.map(materialList => (
                            <li key={materialList?.id} onClick={() => PdCategory({ categoryId: 103, subCategoryId: 4, typeId: materialList?.id, typeName: materialList?.medium })}><Link>{materialList?.medium}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
        {
            buttonText: <>
                <span onClick={(e) => PdCategory({ categoryId: 134, subCategoryId: 0, typeId: 0, typeName: '0' })}>
                    Sculpture<i className="bi bi-grid-fill"></i>
                </span>
            </>, menuItems: [
                <ul className="submenu">
                    <li className="type">Style</li>
                    {
                        sculptureByStyle.map(styleList => (
                            <li key={styleList?.id} onClick={() => PdCategory({ categoryId: 134, subCategoryId: 1, typeId: styleList?.id, typeName: styleList?.style })}><Link>{styleList?.style}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Surface</li>
                    {
                        sculptureBySurface.map(surfaceList => (
                            <li key={surfaceList?.id} onClick={() => PdCategory({ categoryId: 134, subCategoryId: 2, typeId: surfaceList?.id, typeName: surfaceList?.surface })}><Link>{surfaceList?.surface}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Subject</li>
                    {
                        sculptureBySubject.map(subjectList => (
                            <li key={subjectList?.id} onClick={() => PdCategory({ categoryId: 134, subCategoryId: 3, typeId: subjectList?.id, typeName: subjectList?.subject })}><Link>{subjectList?.subject}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Material</li>
                    {
                        sculptureByMaterial.map(materialList => (
                            <li key={materialList?.id} onClick={() => PdCategory({ categoryId: 134, subCategoryId: 4, typeId: materialList?.id, typeName: materialList?.medium })}><Link>{materialList?.medium}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
        {
            buttonText: //<>Featured Artist<i className="bi bi-chevron-down"></i></>, 
                <>
                    <span onClick={() => window.location.href = '/artists'}>
                        Featured Artist<i className="bi bi-grid-fill"></i>
                    </span>
                </>,
            menuItems: [
                <ul className="submenu">
                    <li className="type">Legend Artists</li>
                    {
                        legendArtists.map(artistList1 => (
                            <li key={artistList1?.id} onClick={() => handleArtist(artistList1?.id, artistList1?.artist)}><Link>{artistList1?.artist}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Established Artists</li>
                    {
                        establishedArtists.map(artistList2 => (
                            <li key={artistList2?.id} onClick={() => handleArtist(artistList2?.id, artistList2?.artist)}><Link>{artistList2?.artist}</Link></li>
                        ))
                    }
                </ul>,
                <ul className="submenu">
                    <li className="type">Upcoming Artists</li>
                    {
                        upcomingArtists.map(artistList3 => (
                            <li key={artistList3?.id} onClick={() => handleArtist(artistList3?.id, artistList3?.artist)}><Link>{artistList3?.artist}</Link></li>
                        ))
                    }
                </ul>
            ]
        },
    ];

    const [isScrolled, setIsScrolled] = useState(false);

    const [currencyList, setCurrencyList] = useState([]);
    useEffect(() => {
        fetch('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetailsForBuyer')
            .then(response => response.json())
            .then(data => setCurrencyList(data))
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    useEffect(() => {
        fetchPaintingStyle();
        fetchPaintingSurface();
        fetchPaintingSubject();
        fetchPaintingMaterial();

        fetchDrawingStyle();
        fetchDrawingSurface();
        fetchDrawingSubject();
        fetchDrawingMaterial();

        fetchPrintmakStyle();
        fetchPrintmakSurface();
        fetchPrintmakSubject();
        fetchPrintmakMaterial();

        fetchTapestryStyle();
        fetchTapestrySurface();
        fetchTapestrySubject();
        fetchTapestryMaterial();

        fetchSculptureStyle();
        fetchSculptureSurface();
        fetchSculptureSubject();
        fetchSculptureMaterial();

        fetchLegendArtists();
        fetchEstablished();
        fetchUpcomingArtists();

        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    function handleLogOut() {
        localStorage.removeItem('user-info');

        navigate('/');
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }

    const userInfo = JSON.parse(localStorage.getItem('user-info'));



    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };


    const [hovered, setHovered] = useState(false);
    const handleMouseEtr = () => {
        setHovered(true);
    };
    const handleMouseLve = () => {
        setHovered(false);
    };

    // Commented By Ranjan on 19-09-2024 after appling currency Context
    /* 
    const [currencyValue, setCurrencyValue] = useState(() => {
         const storedValue = localStorage.getItem('selectedCurrency');
         return storedValue ? JSON.parse(storedValue) : { "id": 4, "currency": "INR", "value": 1, "icon": "₹", "code": "IN" };
     }); 
     
     const updateCurrencyValue = (e) => {
         setCurrencyValue(e);
         setHovered(false);
     };  
     */

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [modalVisible, setModalVisible] = useState(false);

    const openModal = () => setModalVisible(true);
    const closeModal = () => setModalVisible(false);

    const handleOption1 = () => {
        navigate(`/buyerSignup`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        closeModal();
    };

    const handleOption2 = () => {
        navigate(`/signup`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        closeModal();
    };

    const [modalVisible1, setModalVisible1] = useState(false);
    const openModal2 = () => setModalVisible1(true);
    const closeModal2 = () => setModalVisible1(false);
    const handleOption3 = () => {
        navigate(`/buyerLogin`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        closeModal2();
    };

    const handleOption4 = () => {
        navigate(`/login`);
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        closeModal2();
    };




    return (
        <>
            <header className={`${isScrolled ? 'scrolled' : ''}`}>
                <div className="top_header">
                    <ul className="top_left">
                        <li><span className="phone">Help ?</span><i className="bi bi-headset"></i>+91-9555511765</li>
                        <li><i className="bi bi-envelope-at-fill"></i>info@indigalleria.com</li>
                        <li>FAQ's</li>
                        <li>
                            <div className={`over_btn ${hovered ? 'open' : ''}`} onMouseEnter={handleMouseEtr} onMouseLeave={handleMouseLve}>
                                <span className="btn_currency"><ReactCountryFlag countryCode={currencyContxt.code} svg /> {currencyContxt.currency} ({currencyContxt.icon})<i className="bi bi-chevron-bi bi-caret-down-fill"></i></span>
                                <ul className="currency_list">
                                    {currencyList.map(item => (
                                        <li key={item.id}
                                            value={item.value}
                                            onClick={(e) => updateCurrencyContxt({ id: item.id, currency: item.currency, value: item.value, icon: item.icon, code: item.code })}>
                                            <span className="btn_currency">
                                                <ReactCountryFlag countryCode={item.code} svg style={{ width: 'auto', height: '12px' }} />
                                                {item.currency} ({item.icon})</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="mid_header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-3">
                                <Link to={'/'} className="logo">
                                    <img src="../../../images/logo-icon.png" alt="" />
                                    <span>Indi<span>G</span>alleria</span>
                                </Link>
                            </div>
                            <div className="col-md-5">
                                <div className="search_query">
                                    <a className="query_search_btn" href="#">
                                        <i className="bi bi-search"></i>
                                    </a>
                                    <input
                                        type="text"
                                        id="searchBox"
                                        name="searchBox"
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        placeholder="Search for Artwork, Artists"
                                        autoComplete="OFF"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') handleKeyPress(e); // Handle Enter key press
                                        }}
                                    />
                                    <button onClick={handleSearchClick}></button> {/* Handle search button click */}
                                    {loading && <div className="search_loader"><img src="../../../images/loader-search.svg" /></div>}
                                    {renderResults()}
                                </div>

                            </div>
                            <div className="col-md-4">
                                <ul className="user_right">
                                    <li>
                                        <div className="dropdown-user">
                                            <span className="user_p dropdownbtn"><i className="bi bi-person"></i>Profile</span>
                                            <div className="dropdown-user-content">
                                                {
                                                    userInfo ?
                                                        <div className="">
                                                            {
                                                                <div key={userInfo.buyer_id} >
                                                                    <p><b>Welcome</b> {userInfo.buyerName}<br /><b>Mobile No.:</b> {userInfo.buyerMobile}<br /><b>Last Login:</b> {userInfo.lastLogin ? formatDate(userInfo.lastLogin) : ''}</p>
                                                                    <Link to={'/myAccount'}>My Account</Link>
                                                                    <Link to={'/myOrders'}>Orders</Link>
                                                                    <Link to={'/myWishlist'}>Wishlist</Link>
                                                                    <button onClick={handleLogOut} className="btn1 mt-2">LogOut</button>
                                                                </div>
                                                            }
                                                        </div>
                                                        :
                                                        <div className="">
                                                            <p style={{ border: '0' }}><b>Welcome: Guest</b><br />To access account &amp; manage orders</p>
                                                            <div className='d-flex justify-content-between'>

                                                                <Link onClick={openModal2} className="btn1">LogIn</Link>
                                                                <Link onClick={openModal} className="btn1">SignUp</Link>
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </li>
                                    <li>

                                        <span className="user_p" onClick={handleWishListClick}>
                                            <i className={`${wishlist > 0 ? "bi bi-suit-heart-fill text-danger" : "bi bi-suit-heart"}`}>
                                                <span className="count">{wishlist}</span>
                                            </i>Wishlist
                                        </span>

                                    </li>
                                    <li>
                                        <span className="user_p" onClick={handleCartClick}>
                                            <i className={`${cart > 0 ? "bi bi-cart-check-fill text-success" : "bi bi-cart"}`}>
                                                <span className="count">{cart}</span>
                                            </i>Bag
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="menu_header">
                    <a className={`logo_icon ${isScrolled ? 'd-block' : 'd-none'}`}><img src="../../../images/logo-icon.png" alt="" /></a>
                    <div className="main_menu">
                        {menuData.map((menu, index) => (
                            <MegaMenu key={index} buttonText={menu.buttonText} menuItems={menu.menuItems} />
                        ))}
                        <li><a target="_blank" href="https://www.indigalleria.com/blog/">Blog</a></li>
                        <li><Link to="/exhibitions">Exhibitions</Link></li>
                    </div>
                </div>

            </header >


            <ContactUs />

            <>
                {isScrolled && (
                    <span className="scrollTop" onClick={scrollToTop}>
                        <i className="bi bi-arrow-up-short"></i>
                    </span>
                )}
            </>

            <Modal
                show={modalVisible}
                onClose={closeModal}
                onOption1={handleOption1}
                onOption2={handleOption2}
            />

            <Modal2
                show={modalVisible1}
                onClose={closeModal2}
                onOption1={handleOption3}
                onOption2={handleOption4}
            />
        </>
    )
};

export default Header;